var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatbotTypeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 90,
    viewBox: "0 0 85 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_32)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22_32",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 82,
    height: 88
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84 1H2V89H84V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.7605 24.7341C75.1297 25.1189 75.7515 25.1189 76.1304 24.7534L83.4851 17.6533C83.9612 17.2012 84.1263 16.5277 83.9223 15.9024C83.7183 15.277 83.1839 14.8345 82.533 14.7383L70.2524 12.9681L64.7533 1.95244C64.4619 1.36558 63.8692 1 63.2086 1C62.5479 1 61.9552 1.36558 61.6638 1.95244L56.1744 12.9777L43.8939 14.7479C43.2429 14.8441 42.7086 15.2867 42.5045 15.912C42.3005 16.5373 42.4657 17.2108 42.9417 17.6629L51.8316 26.2446L49.733 38.3569C49.6164 39.0015 49.8884 39.6365 50.4228 40.0309C50.9571 40.4158 51.6567 40.4639 52.2396 40.1656L63.2086 34.4221L74.197 40.1464C74.4496 40.2811 74.7216 40.3484 75.0034 40.3484C75.3628 40.3484 75.7126 40.233 76.0138 40.0213C76.5481 39.6365 76.8105 38.9919 76.6842 38.2896L71.9235 19.0291C71.7972 18.5096 71.2725 18.1921 70.7479 18.3268C70.2233 18.4518 69.9124 18.9714 70.0387 19.4909L74.673 38.2319L64.015 32.6808C63.5098 32.421 62.9171 32.421 62.4119 32.6808L51.715 38.2319L53.7552 26.4466C53.8524 25.8886 53.6678 25.321 53.2597 24.9362L44.6128 16.5854L56.5728 14.8633C57.1363 14.7864 57.6221 14.4304 57.865 13.9301L63.2086 3.19351L68.5522 13.9205C68.8048 14.4208 69.2906 14.7768 69.8541 14.8537L81.8043 16.5758L74.7702 23.368C74.3913 23.7432 74.3816 24.3493 74.7605 24.7341Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_22_32",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 82,
    height: 88
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84 1H2V89H84V1Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_22_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.86 18.5673C50.4811 18.9425 50.4811 19.5486 50.86 19.9238L54.7462 23.7721C54.9308 23.9549 55.1834 24.0511 55.4361 24.0511C55.6887 24.0511 55.9316 23.9549 56.1259 23.7721C56.5048 23.3969 56.5048 22.7908 56.1259 22.4155L52.2396 18.5673C51.851 18.1921 51.2389 18.1921 50.86 18.5673Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_22_32",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 82,
    height: 88
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84 1H2V89H84V1Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_22_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.578 41.2335L31.6911 34.6241C31.5162 34.3932 31.5162 34.0758 31.6911 33.8352L36.578 27.2259C37.161 26.437 37.2484 25.3979 36.8015 24.5225C36.306 23.5604 35.3053 23.0024 34.188 23.1179L25.8908 24.003C25.6285 24.003 25.3856 23.849 25.2787 23.6085L21.9463 16.114C21.5188 15.1616 20.6055 14.5747 19.5562 14.5747C18.5069 14.5747 17.5839 15.1616 17.1662 16.114L13.8337 23.6085C13.7268 23.849 13.4742 24.0222 13.1439 24.003L4.92447 23.1179C3.79745 23.0024 2.79674 23.5604 2.31096 24.5225C1.86404 25.3979 1.95148 26.4274 2.53442 27.2259L7.42139 33.8352C7.59627 34.0661 7.59627 34.3836 7.42139 34.6241L2.53442 41.2335C1.95148 42.0224 1.86404 43.0614 2.31096 43.9369C2.80646 44.899 3.80717 45.457 4.92447 45.3415L13.2216 44.4564C13.4839 44.4564 13.7268 44.6104 13.8337 44.8509L17.1662 52.3454C17.5937 53.2978 18.5069 53.8943 19.5562 53.8943C20.6055 53.8943 21.5285 53.3074 21.9463 52.3454L25.2787 44.8509C25.3856 44.6104 25.6382 44.4853 25.9685 44.4564L34.188 45.3415C35.3053 45.457 36.3157 44.899 36.8015 43.9369C37.2484 43.0518 37.161 42.0224 36.578 41.2335ZM35.0721 43.0614C35.0235 43.148 34.8486 43.3982 34.4017 43.427L26.1823 42.5419C25.0358 42.4265 23.9574 43.0518 23.5008 44.0716L20.1683 51.5661C20.0129 51.9221 19.6825 51.9605 19.5562 51.9605C19.4202 51.9605 19.0996 51.9221 18.9441 51.5661L15.6117 44.0716C15.1939 43.1288 14.2515 42.5227 13.2216 42.5227C13.1245 42.5227 13.037 42.5323 12.9399 42.5419L4.60385 43.427C4.23466 43.427 4.05977 43.148 4.0112 43.0614C3.96262 42.946 3.85575 42.667 4.07921 42.3688L8.96617 35.7594C9.64627 34.8454 9.64627 33.614 8.96617 32.7L4.07921 26.0906C3.85575 25.7924 3.96262 25.5134 4.02091 25.3979C4.06949 25.3114 4.22494 25.042 4.69129 25.0324L12.9107 25.9175C14.0475 26.0425 15.1259 25.4076 15.5825 24.3878L18.915 16.8933C19.0704 16.5373 19.4008 16.4989 19.5271 16.4989C19.6631 16.4989 19.9837 16.5373 20.1392 16.8933L23.4716 24.3878C23.9283 25.4076 25.0164 26.0425 26.1531 25.9175L34.46 25.0227C34.8292 25.0227 35.0041 25.3017 35.0527 25.3883C35.111 25.4942 35.2178 25.7828 34.9944 26.081L30.1074 32.6904C29.4273 33.6043 29.4273 34.8358 30.1074 35.7498L35.0041 42.3688C35.2275 42.667 35.1207 42.946 35.0721 43.0614Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_22_32",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 82,
    height: 88
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84 1H2V89H84V1Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_22_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4882 29.8331C17.341 29.8331 15.6019 31.5552 15.6019 33.6813C15.6019 35.8075 17.341 37.5296 19.4882 37.5296C21.6353 37.5296 23.3744 35.8075 23.3744 33.6813C23.3744 31.5552 21.6256 29.8331 19.4882 29.8331ZM19.4882 35.6054C18.4195 35.6054 17.5451 34.7396 17.5451 33.6813C17.5451 32.623 18.4195 31.7572 19.4882 31.7572C20.5569 31.7572 21.4313 32.623 21.4313 33.6813C21.4313 34.7396 20.5569 35.6054 19.4882 35.6054Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_22_32",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 82,
    height: 88
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84 1H2V89H84V1Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_22_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.9379 63.0243C64.5785 61.7928 64.083 60.5999 63.4514 59.4743C65.1614 57.5886 65.0934 54.6736 63.2668 52.8649C61.4597 51.0754 58.5742 50.9985 56.6602 52.6147C55.6789 52.1241 54.6005 51.72 53.7649 51.4122C53.6581 51.3737 53.5512 51.3352 53.4443 51.2967C53.3472 48.728 51.2097 46.6692 48.5865 46.6692C46.0022 46.6692 43.8939 48.6703 43.7384 51.1909C42.3588 51.5372 41.0958 52.0375 39.8522 52.7302C37.9382 50.9792 34.9458 51.0273 33.0901 52.8649C31.2538 54.6832 31.1761 57.5982 32.8666 59.4646C32.2254 60.6095 31.7202 61.8024 31.3607 63.0243C28.8055 63.1686 26.7749 65.2659 26.7749 67.825C26.7749 70.3841 28.8055 72.491 31.3607 72.6257C31.7202 73.8667 32.2157 75.0501 32.8472 76.1757C31.1372 78.0613 31.2052 80.9764 33.0318 82.7851C34.8875 84.6226 37.8896 84.6611 39.7939 82.8909C41.0569 83.6028 42.3394 84.1127 43.7481 84.4687C43.9036 86.9893 46.0119 88.9904 48.5962 88.9904C51.2097 88.9904 53.3569 86.9316 53.454 84.3629C53.5512 84.3244 53.6581 84.2859 53.7747 84.2474C54.6296 83.9299 55.7469 83.5162 56.7379 83.0063C58.6519 84.6803 61.4889 84.613 63.3251 82.7947C65.1517 80.986 65.2003 78.0517 63.4612 76.1661L63.4126 76.0314L63.3543 76.0506C63.3349 76.0314 63.3154 76.0121 63.296 75.9929L63.1794 76.1083L61.5763 76.6471L61.7609 77.1955L61.9261 77.359C63.0725 78.4943 63.0822 80.3222 61.9552 81.4382C60.8379 82.5445 59.0988 82.5638 57.9524 81.4959L57.2723 80.4761L56.495 80.9571C55.504 81.5536 54.1633 82.0731 53.1529 82.4483C52.774 82.5927 52.5116 82.7177 52.2493 82.8235L51.7927 83.0737V84.1897C51.7927 85.7771 50.4811 87.0759 48.878 87.0759C47.2749 87.0759 45.9633 85.7771 45.9633 84.1897V82.9294L45.05 82.7754C43.3595 82.4195 41.7467 81.8519 40.2894 80.9668L39.7841 80.6589L38.7154 81.3035L38.5308 81.4478C37.3941 82.5734 35.5481 82.5734 34.4114 81.4478C33.2747 80.3222 33.2747 78.4943 34.4114 77.3686L35.2955 76.4932L34.8972 75.8486C34.0519 74.4825 33.4398 73.0105 33.0609 71.4616L32.8763 70.7208H31.6327C30.0296 70.7208 28.718 69.422 28.718 67.8346C28.718 66.2472 30.0296 64.9484 31.6327 64.9484H32.8763L33.0609 64.2172C33.4301 62.6972 34.0519 61.2156 34.9069 59.8302L35.2955 59.1953L34.4405 58.3102C33.3135 57.1942 33.3232 55.3566 34.4697 54.231C35.6064 53.115 37.5301 53.115 38.6571 54.231L39.755 55.0488L40.3574 54.712C41.8244 53.8269 43.3595 53.2497 45.05 52.9034L45.9633 52.7398V51.4795C45.9633 49.8921 47.2749 48.5933 48.878 48.5933C50.4811 48.5933 51.7927 49.8921 51.7927 51.4795V52.5955L52.2493 52.8456C52.5116 52.9515 52.6962 53.0765 53.0751 53.2208C54.0856 53.596 55.4652 54.1156 56.4562 54.712L57.486 55.3374L57.9135 54.0963C59.06 53.115 60.7991 53.1631 61.8872 54.2406C63.024 55.3662 63.024 57.1942 61.8872 58.3198L61.0031 59.1953L61.4014 59.8398C62.2467 61.1963 62.8588 62.6779 63.2377 64.2269L63.4223 64.958H64.6659C66.269 64.958 67.9498 66.2568 67.9498 67.8442C67.9498 69.4316 66.3759 70.7304 65.4043 70.7304V72.6545C67.3474 72.6545 69.9026 70.4995 69.9026 67.8442C69.8832 65.2659 67.4834 63.1686 64.9379 63.0243Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_22_32",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 82,
    height: 88
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84 1H2V89H84V1Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_22_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.878 74.569V76.4932C52.7642 76.4932 56.2813 73.0394 56.2813 68.7967C56.2813 64.554 52.4242 61.1001 48.1396 61.1001C43.855 61.1001 40.3671 64.9484 40.3671 68.7967H42.3102C42.3102 65.9105 45.1083 63.0243 48.3242 63.0243C51.54 63.0243 54.3382 65.6122 54.3382 68.7967C54.3382 71.9811 51.7927 74.569 48.878 74.569Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_22_32",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 82,
    height: 88
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84 1H2V89H84V1Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_22_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7661 73.1933C42.3879 74.0784 43.204 74.8384 44.1367 75.3868L45.1374 73.7417C44.4379 73.328 43.8258 72.7507 43.3595 72.0869L41.7661 73.1933Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 88,
    fill: "white",
    transform: "translate(2 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotTypeIcon);
export default __webpack_public_path__ + "static/media/chatbot-type-icon.75a2c296d3f9999a75ab7b2f4bcf349f.svg";
export { ForwardRef as ReactComponent };